import { customMessageTypeValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/CustomMessage/constants'

export const feeApplicationModeValues = {
  perRequest: 'per_request',
  perMatchingProduct: 'per_matching_product',
}

export const customMessageTypeOptions = [customMessageTypeValues.info, customMessageTypeValues.warning]
